var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',[_c('v-row',[_c('p',[_vm._v(" Hướng dẫn sử dụng fplus với codesim.net ")])]),(_vm.result)?_c('v-row',[_c('iframe',{attrs:{"width":"640","height":"480","src":_vm.result,"allow":"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }